module.exports = __webpack_public_path__ + "img/hy_tjhby.25d729d8.svg";